/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatisticalReportApiRequest } from '../../models/statistical-report-api-request';

export interface ApiHotelStatisticalReportDinnerPost$Params {
      body?: StatisticalReportApiRequest
}

export function apiHotelStatisticalReportDinnerPost(http: HttpClient, rootUrl: string, params?: ApiHotelStatisticalReportDinnerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelStatisticalReportDinnerPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelStatisticalReportDinnerPost.PATH = '/api/hotel/StatisticalReport/Dinner';
